import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../ReduxToolkit/Hooks';
import { Image, SVG, P, H3, H2 } from '../../AbstractElements';
import { handleResponsiveToggle, setToggleSidebar } from '../../ReduxToolkit/Reducers/LayoutSlice';
import { dynamicImage } from '../../Service';
import { FontSize } from '../../utils/Constant';

const LogoWrapper = () => {
  const dispatch = useAppDispatch();
  const { toggleSidebar } = useAppSelector((state) => state.layout)
  const { sidebarIconType } = useAppSelector((state) => state.themeCustomizer)

  return (
    <>
      <div className="logo-wrapper pb-0 d-flex align-items-center justify-content-between">
        <Link className='d-flex align-items-center' to={`/`}>
          <Image className="img-fluid for-light" src={dynamicImage("logo/logo.png")} alt="looginpage" width={150} />
        </Link>
        <div className="back-btn d-flex" onClick={() => dispatch(handleResponsiveToggle())}>
          <i className="fa fa-angle-left" style={{ color: "#8c2dbf", cursor: "pointer", fontSize: 26, fontWeight: 600 }}></i>
        </div>
        <div className="toggle-sidebar">
          <SVG className={`${sidebarIconType}-icon sidebar-toggle status_toggle middle`} iconId={`${sidebarIconType === "fill" ? "fill-" : ""}toggle-icon`} onClick={() => dispatch(setToggleSidebar(!toggleSidebar))} />
        </div>
      </div>
      <div className="logo-icon-wrapper p-2">
        <Link to={`/`}>
          <Image className="img-fluid" src={dynamicImage("logo/logo.png")} alt="logo" width={60} />
        </Link>
      </div>
    </>
  );
}

export default LogoWrapper